import { render, staticRenderFns } from "./LmDialog.vue?vue&type=template&id=0522ed70&scoped=true&functional=true&"
import script from "./LmDialog.vue?vue&type=script&lang=js&"
export * from "./LmDialog.vue?vue&type=script&lang=js&"
import style0 from "./LmDialog.vue?vue&type=style&index=0&id=0522ed70&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "0522ed70",
  null
  
)

export default component.exports